// extracted by mini-css-extract-plugin
module.exports = {"top":"Support_top__eKnId","content":"Support_content__k_N9B","welcome":"Support_welcome__ZtElu"};